const CREDENTIALS_CONTEXT_V1_URL = "https://www.w3.org/2018/credentials/v1";

module.exports = {
  CREDENTIALS_CONTEXT_V1_URL,
};
